module.exports = __webpack_public_path__ + "img/40_37_028_070.86a14399.jpg";